<template>
  <div class="animated fadeIn">
    <b-alert :variant="alertVariant" dismissible :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ message }}
    </b-alert>

    <b-row v-if="multi || !banners || banners.length === 0" style="border: 1px dashed black; margin: 10px">
      <b-col style="padding: 10px">
        <h5>{{ multi ? 'Upload Banner' : 'Banner Announcement' }}</h5>

        <template v-if="multi">
          <b-row>
            <b-col md="3">
              <label>Title</label>
              <input type="text" class="form-control" v-model="bannerForm.title">
            </b-col>
            <b-col v-if="allowDetails" md="4">
              <label>Description</label>
              <input type="text" class="form-control" v-model="bannerForm.description">
            </b-col>
            <b-col v-if="allowDetails" md="12" style="margin-top: 10px">
              <label>Article</label>
              <textarea class="form-control" rows="5" v-model="bannerForm.article"></textarea>
            </b-col>
            <b-col md="2">
              <label>Sort Order</label>
              <input type="number" class="form-control" v-model="bannerForm.sortOrder">
            </b-col>
            <b-col md="1">
              <label>Active</label>
              <div>
                <input type="checkbox" v-model="bannerForm.active">
              </div>
            </b-col>
            <b-col v-if="allowImage" md="2">
              <label>Image</label>
              <input type="file" class="form-control-file" @change="fileChange($event.target.files)" accept="image/*">
            </b-col>
          </b-row>
          <br>
          <button type="button" class="btn btn-primary" @click="uploadBanner()" :disabled="loading">Upload</button>
          <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="loading">Refresh</button>
          <span v-if="uploadProgress > 0"> Upload {{ uploadProgress }}%</span>
        </template>

        <template v-else>
          <b-row>
            <b-col md="8">
              <label>Title</label>
              <input type="text" class="form-control" v-model="bannerForm.title">
            </b-col>
          </b-row>
          <br>
          <button type="button" class="btn btn-primary" @click="saveSingleBanner()" :disabled="loading">Save</button>
          <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="loading">Refresh</button>
        </template>
      </b-col>
    </b-row>

    <b-table small bordered hover :items="banners" :fields="bannerFields">
      <template slot="cell(preview)" slot-scope="row">
        <img :src="row.item.imageUrl" alt="Banner" style="height: 70px; max-width: 180px; object-fit: cover">
      </template>

      <template slot="cell(title)" slot-scope="row">
        <input type="text" class="form-control" v-model="row.item.title">
      </template>

      <template slot="cell(description)" slot-scope="row">
        <input type="text" class="form-control" v-model="row.item.description">
      </template>

      <template slot="cell(article)" slot-scope="row">
        <textarea class="form-control" rows="4" v-model="row.item.article"></textarea>
      </template>

      <template slot="cell(sortOrder)" slot-scope="row">
        <input type="number" class="form-control" v-model="row.item.sortOrder">
      </template>

      <template slot="cell(active)" slot-scope="row">
        <input type="checkbox" v-model="row.item.active">
      </template>

      <template slot="cell(actions)" slot-scope="row">
        <button type="button" class="btn btn-sm btn-primary" @click="updateBanner(row.item)" :disabled="loading">Save</button>
        <button v-if="!multi" type="button" class="btn btn-sm btn-secondary" @click="toggleBannerVisibility(row.item)" :disabled="loading">
          {{ row.item.active ? 'Hide' : 'Show' }}
        </button>
        <button v-if="multi" type="button" class="btn btn-sm btn-danger" @click="deleteBanner(row.item)" :disabled="loading">Delete</button>
      </template>
    </b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..."
         style="margin-left:auto; margin-right:auto; display: block;"
         v-if="loading">
  </div>
</template>

<script>
export default {
  name: 'Banners',
  data () {
    return {
      fileToUpload: null,
      bannerForm: {
        title: '',
        description: '',
        article: '',
        sortOrder: 0,
        active: true
      }
    }
  },
  created: function () {
    this.$store.dispatch('bannermod/fetchBanners')
  },
  computed: {
    multi: function () {
      return this.$store.state.bannermod.multi
    },
    banners: function () {
      return this.$store.state.bannermod.banners
    },
    allowImage: function () {
      return this.$store.state.bannermod.allowImage
    },
    allowDetails: function () {
      return this.$store.state.bannermod.allowDetails
    },
    bannerFields: function () {
      return this.$store.getters['bannermod/bannerFields']
    },
    loading: function () {
      return this.$store.state.bannermod.loading
    },
    uploadProgress: function () {
      return this.$store.state.bannermod.uploadProgress
    },
    alertVariant: function () {
      return this.$store.state.bannermod.alertVariant
    },
    showDismissibleAlert: {
      get: function () {
        return this.$store.state.bannermod.showDismissibleAlert
      },
      set: function (dismiss) {
        this.$store.commit('bannermod/closeDismissibleAlert', dismiss)
      }
    },
    message: function () {
      return this.$store.state.bannermod.message
    }
  },
  watch: {
    banners: function (banners) {
      if (!this.multi && banners && banners.length > 0) {
        this.bannerForm.title = banners[0].title || ''
      }
    }
  },
  methods: {
    fileChange: function (fileList) {
      this.fileToUpload = fileList && fileList.length > 0 ? fileList[0] : null
    },
    uploadBanner: function () {
      if (!this.multi) {
        this.saveSingleBanner()
        return
      }
      this.$store.dispatch('bannermod/uploadBanner', {
        title: this.bannerForm.title,
        description: this.bannerForm.description,
        article: this.bannerForm.article,
        sortOrder: this.bannerForm.sortOrder,
        active: this.bannerForm.active,
        file: this.fileToUpload
      })
      this.bannerForm.article = ''
      this.fileToUpload = null
    },
    saveSingleBanner: function () {
      this.$store.dispatch('bannermod/saveSingleBanner', {
        title: this.bannerForm.title
      })
    },
    refreshTable: function () {
      this.$store.dispatch('bannermod/fetchBanners')
    },
    updateBanner: function (banner) {
      this.$store.dispatch('bannermod/updateBanner', banner)
    },
    toggleBannerVisibility: function (banner) {
      this.$store.dispatch('bannermod/updateBanner', Object.assign({}, banner, {
        active: !banner.active
      }))
    },
    deleteBanner: function (banner) {
      if (!this.multi) {
        return
      }
      if (confirm('Delete this banner?')) {
        this.$store.dispatch('bannermod/deleteBanner', banner)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Banners.vue